import { loader } from '../../page-reveal/loader.js'
import { revealOnSwup } from '../../page-reveal/reveal-controller.js'

// Thin swup binding: raise the mask on `out`, then hand off to the reveal controller on
// `in` (which settles the new page behind the mask and calls loader.hide()). The mask
// visual lives in the loader module; this transition carries no loader specifics.
export const defaultTransition = {
	from: '(.*)',
	to: '(.*)',
	out: async () => {
		await loader.show({ animate: true })
	},
	in: async () => {
		await revealOnSwup()
	},
}
